var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 97,
    viewBox: "0 0 110 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6302 50.6465C63.5898 50.6465 74.9063 39.3089 74.9063 25.3232C74.9063 11.3376 63.5898 0 49.6302 0C35.6706 0 24.354 11.3376 24.354 25.3232C24.354 39.3089 35.6706 50.6465 49.6302 50.6465Z",
    fill: "#E22A27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5227 57.1675C60.9122 62.656 59.7189 68.2532 59.7189 75.9698C59.7189 81.4583 63.3531 87.6532 63.3531 87.6532H0V87.3815C0 69.0683 14.8077 54.1787 33.141 54.1787H60.641C63.0276 54.1787 65.9566 54.1787 67.5838 54.8852C66.8245 55.6459 66.1736 56.4067 65.5227 57.1675Z",
    fill: "#E22A27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.769 60.4824C104.467 58.6347 102.894 57.0045 101.159 55.5916C97.2534 52.4941 92.2633 50.6465 86.8935 50.6465C79.7337 50.6465 73.3876 53.907 69.1026 59.0151C65.7397 63.0364 63.7327 68.1989 63.7327 73.8504C63.7327 76.1871 64.0582 78.4151 64.7091 80.5345C64.8718 81.1322 65.0888 81.6756 65.3057 82.2191C65.6854 83.2515 66.1736 84.2297 66.716 85.1535C70.6755 92.2179 78.215 97 86.8935 97C99.64 97 110 86.6207 110 73.8504C110 68.851 108.427 64.2319 105.769 60.4824ZM100.833 83.1429L96.2229 87.7619L86.8935 78.4151L77.5641 87.7619L72.9537 83.1429L82.283 73.7961L72.9537 64.4493L77.5641 59.8303L86.8935 69.177L96.2229 59.8303L100.833 64.4493L91.5039 73.7961L100.833 83.1429Z",
    fill: "#EF5756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTimes);
export default __webpack_public_path__ + "static/media/userTimes.5844e39813f32e7ff70610960843a336.svg";
export { ForwardRef as ReactComponent };